import React from 'react';

import colors from '../../customizations/js/color-variables';

export const IconsDefs = () => (
  <svg width="0" height="0">
    <defs>
      {/* Gradient */}
      <linearGradient id="linear-gradient-primary" x1="0%" y1="0%" y2="100%">
        <stop offset="0%" stopColor={colors.razzmatazz} />
        <stop offset="100%" stopColor={colors.sunsetOrange} />
      </linearGradient>
      {/* end Gradient */}

      {/* IconUser */}
      <clipPath id="icon-user-0">
        <path className="icon-filled-path icon-stroked-path" fill="#fff" d="M0 0h320v1208H0z" transform="translate(-113 -11)" />
      </clipPath>
      {/* end IconUser */}

      {/* IconAlert */}
      <clipPath id="icon-alert">
        <rect width="12" height="12" fill="white" transform="translate(4 4.5)" />
      </clipPath>

      <clipPath id="icon-alert-outlined">
        <rect width="27.4286" height="27.4286" fill="white" transform="translate(12.2852 12.2857)" />
      </clipPath>
      {/* end IconAlert */}

      {/* IconGameTags */}
      <clipPath id="icon-game-tags-clip">
        <rect width="26" height="26" fill="white" />
      </clipPath>
      {/* IconGameTags end */}

      {/* Characters shape gradient */}
      <linearGradient id="linear-gradient-characters-shape" x1="85.309%" x2="57.183%" y1="83.286%" y2="19.874%">
        <stop offset="0%" stopColor="#35353C" />
        <stop offset="100%" stopColor="#545457" />
      </linearGradient>
      <linearGradient id="linear-gradient-characters-shape-active" x1="27.737%" x2="50%" y1="6.549%" y2="79.5%">
        <stop offset="0%" stopColor="#0E97FF" />
        <stop offset="100%" stopColor="#006BFF" />
      </linearGradient>
      {/* end Characters shape gradient */}

      {/* Loyalty Card Active shape gradient */}
      <linearGradient id="linear-gradient-loyalty-card-shape-active" x1="27.737%" x2="50%" y1="6.549%" y2="79.5%">
        <stop offset="0%" stopColor="#0E97FF" />
        <stop offset="100%" stopColor="#006BFF" />
      </linearGradient>
      {/* end Loyalty Card gradient */}

      {/* IconHomeLink */}
      <path id="icon-home-link" d="M0 0h24v26.4H0z" />
      <linearGradient id="icon-home-link-active" x1="8.678%" x2="91.322%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#FF0061" />
        <stop offset="100%" stopColor="#FF4949" />
      </linearGradient>
      {/* end IconHomeLink */}

      {/* IconErrorCircle */}
      <linearGradient id="icon-error-circle" x1="0%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#FF0061" />
        <stop offset="100%" stopColor="#FF4949" />
      </linearGradient>
      {/* end IconErrorCircle */}

      {/* IconLaurelWreath */}
      <linearGradient id="laurel-wreath-a" x1="19.153%" x2="77.633%" y1="16.798%" y2="90.79%">
        <stop offset="0%" stopColor="#EAFAFF" />
        <stop offset="100%" stopColor="#9EAFB9" />
      </linearGradient>
      {/* end  IconLaurelWreath */}

      {/* IconLevelAccomplished */}
      <linearGradient id="icon-level-accomplished-c" x1="0%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#FF4949" />
        <stop offset="100%" stopColor="#FF0061" />
      </linearGradient>
      <rect id="icon-level-accomplished-b" width="48.96" height="48.96" x="3.84" y="5.76" rx="24.48" />
      <filter id="icon-level-accomplished-a" width="206.2%" height="206.2%" x="-53.1%" y="-26.6%" filterUnits="objectBoundingBox">
        <feOffset dy="13" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="6.5" />
        <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.309276661 0" />
      </filter>
      {/* end IconLevelAccomplished */}

      {/* IconLangRu */}
      <rect id="icon-lang-ru-a" width="30" height="24" rx="4" />
      <rect id="icon-lang-ru-c" width="30" height="24" rx="4" />
      <filter id="icon-lang-ru-d" width="116.7%" height="120.8%" x="-8.3%" y="-10.4%" filterUnits="objectBoundingBox">
        <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="1.5" />
        <feOffset dy="2" in="shadowBlurInner1" result="shadowOffsetInner1" />
        <feComposite in="shadowOffsetInner1" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner1" />
        <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0" />
      </filter>
      <mask id="icon-lang-ru-b" fill="#fff">
        <use xlinkHref="#icon-lang-ru-a" />
      </mask>
      {/* end IconLangRu */}

      {/* IconLangEn */}
      <rect id="icon-lang-en-a" width="30" height="24" rx="4" />
      <rect id="icon-lang-en-c" width="30" height="24" rx="4" />
      <filter id="icon-lang-en-d" width="116.7%" height="120.8%" x="-8.3%" y="-10.4%" filterUnits="objectBoundingBox">
        <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="1.5" />
        <feOffset dy="2" in="shadowBlurInner1" result="shadowOffsetInner1" />
        <feComposite in="shadowOffsetInner1" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner1" />
        <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0" />
      </filter>
      <mask id="icon-lang-en-b" fill="#fff">
        <use xlinkHref="#icon-lang-en-a" />
      </mask>
      {/* end IconLangEn */}

      {/* IconHabanero */}
      <linearGradient id="icon-habanero-0" x1="162.92" y1="560.637" x2="611.51" y2="560.637" gradientUnits="userSpaceOnUse">
        <stop stopColor="#ED334D" />
        <stop offset="1" stopColor="#F79826" />
      </linearGradient>
      {/* end IconHabanero */}

      {/* IconNewLevelBg */}
      <path id="icon-new-level-bg-a" d="M0 0h480v497H0z" />
      <radialGradient id="icon-new-level-bg-b" r="43.364%" fx="50%" fy="50%" gradientTransform="rotate(76.658 .52 .516) scale(1 1.06329)">
        <stop offset="0%" stopColor="#88B5FF" stopOpacity=".117" />
        <stop offset="60.037%" stopColor="#88CEFF" stopOpacity=".022" />
        <stop offset="100%" stopColor="#188FC0" stopOpacity="0" />
      </radialGradient>
      <mask id="icon-new-level-bg-c" fill="#fff">
        <use xlinkHref="#icon-new-level-bg-a" />
      </mask>
      {/* end IconNewLevelBg */}

      {/* IconClock */}
      <linearGradient id="icon-clock" x1="0%" y1="0%" y2="100%">
        <stop offset="0%" stopColor={colors.white} />
        <stop offset="100%" stopColor={colors.white} />
      </linearGradient>
      <linearGradient id="icon-clock-active" x1="0%" y1="0%" y2="100%">
        <stop offset="0%" stopColor={colors.razzmatazz} />
        <stop offset="100%" stopColor={colors.sunsetOrange} />
      </linearGradient>
      {/* end IconClock */}

      {/* IconMenu */}
      <clipPath id="icon-menu-0">
        <path fill="#fff" d="M0 0h320v568H0z" transform="translate(-15 -16)" />
      </clipPath>
      {/* end IconMenu */}

      {/* IconPwaLogo */}
      <linearGradient id="icon-pwa-logo-b" x1="0%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#F41A4F" />
        <stop offset="100%" stopColor="#FF4949" />
      </linearGradient>
      <rect id="icon-pwa-logo-a" width="78" height="78" rx="16" />
      <radialGradient id="icon-pwa-logo-c" r="172.947%" fx="50%" fy="50%" gradientTransform="rotate(67.25 .524 .516) scale(1 1.06329)">
        <stop offset="0%" stopColor="#FFF" stopOpacity=".155" />
        <stop offset="23.841%" stopColor="#FFF" stopOpacity="0" />
        <stop offset="100%" stopColor="#C09218" stopOpacity="0" />
      </radialGradient>
      <linearGradient id="icon-pwa-logo-e" x1="50%" x2="50%" y1="0%" y2="98.781%">
        <stop offset="0%" stopColor="#FFE424" />
        <stop offset="100%" stopColor="#FFC30E" />
      </linearGradient>
      <mask id="icon-pwa-logo-d" fill="#fff">
        <use xlinkHref="#icon-pwa-logo-a" />
      </mask>
      {/* end IconPwaLogo */}

      {/* IconChrome */}
      <linearGradient id="icon-chrome-a" x1="49.941%" x2="49.941%" y1=".144%" y2="100.032%">
        <stop offset="0%" stopColor="#81B4E0" />
        <stop offset="100%" stopColor="#0C5A94" />
      </linearGradient>
      <linearGradient id="icon-chrome-b" x1="50%" x2="50%" y1=".137%" y2="71.693%">
        <stop offset="0%" stopColor="#F06B59" />
        <stop offset="100%" stopColor="#DF2227" />
      </linearGradient>
      <linearGradient id="icon-chrome-c" x1="26.279%" x2="49.134%" y1="81.958%" y2="38.282%">
        <stop offset="0%" stopColor="#388B41" />
        <stop offset="100%" stopColor="#4CB749" />
      </linearGradient>
      <linearGradient id="icon-chrome-d" x1="58.422%" x2="35.677%" y1="85.352%" y2="12.208%">
        <stop offset="0%" stopColor="#E4B022" />
        <stop offset="30%" stopColor="#FCD209" />
      </linearGradient>
      <linearGradient id="icon-chrome-e" x1="49.999%" x2="49.999%" y1="96.296%" y2="-2.466%">
        <stop offset="0%" stopOpacity=".15" />
        <stop offset="30%" stopOpacity=".06" />
        <stop offset="100%" stopOpacity=".03" />
      </linearGradient>
      <linearGradient id="icon-chrome-f" x1="71.06%" x2="28.821%" y1="8.54%" y2="78.539%">
        <stop offset="0%" stopOpacity=".15" />
        <stop offset="30%" stopOpacity=".06" />
        <stop offset="100%" stopOpacity=".03" />
      </linearGradient>
      <linearGradient id="icon-chrome-g" x1="39.927%" x2="47.694%" y1="66.865%" y2="52.759%">
        <stop offset="0%" stopOpacity=".15" />
        <stop offset="30%" stopOpacity=".06" />
        <stop offset="100%" stopOpacity=".03" />
      </linearGradient>
      {/* end IconChrome */}

      {/* IconSmallMinDeposit */}
      <linearGradient id="icon-min-deposit-a" x1="59.783%" x2="106.282%" y1="-67.372%" y2="125.631%">
        <stop offset="0%" stopColor="#61B8FF" />
        <stop offset="14.168%" stopColor="#2793F9" />
        <stop offset="100%" stopColor="#0047FF" />
      </linearGradient>
      {/* end IconSmallMinDeposit */}

      {/* IconSecurePayments */}
      <linearGradient id="icon-secure-payments-a" x1="56.601%" x2="87.976%" y1="-79.402%" y2="133.384%">
        <stop offset="0%" stopColor="#61B8FF" />
        <stop offset="14.168%" stopColor="#2793F9" />
        <stop offset="100%" stopColor="#0047FF" />
      </linearGradient>
      {/* end IconSecurePayments */}

      {/* IconSupport */}
      <linearGradient id="icon-support-a" x1="59.783%" x2="106.282%" y1="-79.402%" y2="133.384%">
        <stop offset="0%" stopColor="#61B8FF" />
        <stop offset="14.168%" stopColor="#2793F9" />
        <stop offset="100%" stopColor="#0047FF" />
      </linearGradient>
      {/* end IconSupport */}

      {/* IconVisa Promo */}
      <linearGradient id="icon-visa-payment-promo-a" x1="0%" y1="49.187%" y2="50.555%">
        <stop offset="0%" stopColor="#242867" />
        <stop offset="100%" stopColor="#2041A1" />
      </linearGradient>
      <path id="icon-visa-payment-promo-b" d="M42.366 0c1.61-.007 3.208.282 4.716.854l-.715 4.328-.476-.213a9.042 9.042 0 0 0-3.916-.767c-2.075 0-3.005.871-3.027 1.725 0 .938 1.125 1.556 2.964 2.472 3.029 1.43 4.433 3.177 4.413 5.459-.043 4.155-3.633 6.842-9.15 6.842-2.358-.022-4.63-.514-5.863-1.068l.736-4.497.693.321c1.708.747 2.832 1.065 4.931 1.065 1.515 0 3.136-.619 3.158-1.96 0-.874-.691-1.515-2.725-2.495-1.99-.96-4.65-2.558-4.607-5.436.021-3.9 3.677-6.63 8.868-6.63zM31.314.364L28.026 20.4h-5.257L26.057.364h5.257zm29.243 0L64.8 20.4h-4.868s-.477-2.302-.627-3.007h-6.75l-1.104 3.007h-5.515l7.806-18.374c.541-1.3 1.495-1.663 2.749-1.663h4.066zm-42.18 0v.002h5.56l-8.263 20.016h-5.558L5.59 3.562C3.962 2.602 2.095 1.832 0 1.3L.086.9h8.35c1.132.042 2.05.402 2.349 1.67l1.534 7.714c.136.326.253.652.35.975l.56 2.771L18.379.364zm38.481 5.414c-.26.745-.713 1.962-.691 1.918 0 0-1.665 4.457-2.1 5.607h4.37c-.216-1.002-1.212-5.8-1.212-5.8z" />
      {/* end IconVisa */}

      {/* IconSkrill Promo */}
      <path id="icon-skrill-payment-promo-a" d="M49.384 2.035l5.166-.903v19.36h-5.166V2.035zm7.545 0v18.457H62.1V1.132l-5.171.903zM42.023 20.492h5.17V6.332h-5.17v14.16zM7.859 8.334c-.653-.042-2.166-.137-2.166-1.466 0-1.604 2.178-1.604 2.995-1.604 1.436 0 3.296.414 4.625.802 0 0 .74.255 1.371.516l.06.016V2.205l-.081-.023c-1.568-.535-3.391-1.05-6.77-1.05C2.064 1.132 0 4.445 0 7.283c0 1.636.719 5.487 7.392 5.93.566.035 2.068.119 2.068 1.493 0 1.134-1.23 1.802-3.297 1.802-2.266 0-4.464-.564-5.799-1.098v4.523c1.999.512 4.252.767 6.892.767 5.698 0 8.25-3.135 8.25-6.241 0-3.523-2.856-5.812-7.647-6.125zm31.25-2.21c-4.778.15-7.203 2.242-7.203 6.4v7.968h5.212v-6.497c0-2.49.334-3.558 3.362-3.66V6.197c-.509-.105-1.37-.073-1.37-.073zm-14.024.192c-.115.282-.942 2.564-2.944 4.929V1.132L16.806 2.16v18.33h5.335v-5.666c1.545 2.262 2.307 5.667 2.307 5.667h6.39c-.632-2.565-3.397-7.293-3.397-7.293 2.482-3.07 3.571-6.341 3.745-6.883h-6.1zm19.522-1.343c1.407 0 2.549-1.113 2.549-2.486 0-1.373-1.142-2.487-2.55-2.487C43.2 0 42.06 1.114 42.06 2.487s1.14 2.486 2.547 2.486z" />
      <linearGradient id="icon-skrill-payment-promo-a" x1="59.783%" x2="106.282%" y1="-79.402%" y2="133.384%">
        <stop offset="0%" stopColor="#61B8FF" />
        <stop offset="14.168%" stopColor="#2793F9" />
        <stop offset="100%" stopColor="#0047FF" />
      </linearGradient>
      {/* end IconSkrill */}

      {/* IconStarFilled */}
      <linearGradient id="icon-star-gradient" x1="49.956%" x2="50%" y1="-17.297%" y2="100%">
        <stop offset="0%" stopColor="#FFE211" />
        <stop offset="25.845%" stopColor="#FFE211" />
        <stop offset="100%" stopColor="#FFC107" />
      </linearGradient>
      {/* end IconStarFilled */}

      {/* IconChat Primary */}
      <linearGradient id="icon-chat-a-primary" x1="37.811%" x2="65.855%" y1="108.808%" y2="5.401%">
        <stop offset="0%" stopColor={colors.razzmatazz} />
        <stop offset="100%" stopColor={colors.sunsetOrange} />
      </linearGradient>
      {/* IconChat Primary */}

      {/* IconChat Secondary */}
      <linearGradient id="icon-chat-a-secondary" x1="76.534%" x2="65.879%" y1="-34.715%" y2="128.067%">
        <stop offset="0%" stopColor="#25A1FF" />
        <stop offset="100%" stopColor="#2800FF" />
      </linearGradient>
      {/* end IconChat Secondary */}

      {/* IconShine */}
      <radialGradient id="icon-shine-a" cx="50.516%" cy="50.443%" r="27.158%" fx="50.516%" fy="50.443%" gradientTransform="matrix(0 1 -1.11006 0 1.065 0)">
        <stop offset="0%" stopColor="#FFF" stopOpacity=".117" />
        <stop offset="59.816%" stopColor="#FFF" stopOpacity=".022" />
        <stop offset="100%" stopColor="#FFF" stopOpacity="0" />
      </radialGradient>
      {/* end IconShine */}

      {/* IconShineLarge */}
      <radialGradient id="icon-shine-large-a" r="132.317%" fx="50%" fy="50%" gradientTransform="rotate(67.131 .524 .516) scale(1 1.06329)"><stop offset="0%" stopColor="#FFF" stopOpacity=".027" /><stop offset="14.213%" stopColor="#FFCFBD" stopOpacity=".105" />
        <stop offset="25.681%" stopColor="#FFF" stopOpacity="0" />
        <stop offset="100%" stopColor="#C09218" stopOpacity="0" />
      </radialGradient>
      {/* end IconShineLarge */}

      {/* IconWithdrawalDeny */}
      <linearGradient id="icon-withdrawal-deny-a" x1="189.129%" x2="10.9%" y1="-57.338%" y2="86.125%">
        <stop offset="0%" stopColor="#00DD61" />
        <stop offset="100%" stopColor="#006E3A" />
      </linearGradient>
      <linearGradient id="icon-withdrawal-deny-b" x1="10.776%" x2="72.022%" y1="0%" y2="97.444%">
        <stop offset="0%" stopColor="#00DD61" />
        <stop offset="100%" stopColor="#00A056" />
      </linearGradient>
      <linearGradient id="icon-withdrawal-deny-c" x1="59.628%" x2="35.12%" y1="100%" y2="-10.283%">
        <stop offset="0%" stopColor="#CCFFDA" stopOpacity="0" />
        <stop offset="100%" stopColor="#C9FFD7" stopOpacity=".776" />
        <stop offset="100%" stopColor="#61FFA2" />
      </linearGradient>
      <linearGradient id="icon-withdrawal-deny-d" x1="-3.342%" x2="95.223%" y1="48.796%" y2="52.814%">
        <stop offset="0%" stopColor="#FFAC43" />
        <stop offset="84.591%" stopColor="#A34600" />
        <stop offset="100%" stopColor="#A37F00" />
      </linearGradient>
      <linearGradient id="icon-withdrawal-deny-e" x1="-3.342%" x2="95.223%" y1="49.116%" y2="52.067%">
        <stop offset="0%" stopColor="#FFF27D" />
        <stop offset="100%" stopColor="#FF9800" />
      </linearGradient>
      {/* end  IconWithdrawalDeny */}

      {/* IconGiftGray */}
      <linearGradient x1="57.6121636%" y1="13.5754779%" x2="92.1876894%" y2="105.19282%" id="icon-gift-gray-1">
        <stop stopColor="#313137" offset="0%" />
        <stop stopColor="#212126" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="125.661507%" x2="50%" y2="2.07981419%" id="icon-gift-gray-2">
        <stop stopColor="#FFFFFF" stopOpacity="0" offset="0%" />
        <stop stopColor="#FFFFFF" stopOpacity="0.0643848339" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="2.32073848%" x2="50%" y2="100%" id="icon-gift-gray-3">
        <stop stopColor="#212126" stopOpacity="0.7" offset="0%" />
        <stop stopColor="#212126" stopOpacity="0" offset="100%" />
      </linearGradient>
      <linearGradient x1="59.866574%" y1="0%" x2="59.866574%" y2="86.1988367%" id="icon-gift-gray-4">
        <stop stopColor="#313137" offset="0%" />
        <stop stopColor="#212126" offset="100%" />
      </linearGradient>
      <linearGradient x1="40.8125493%" y1="48.2421875%" x2="77.8540278%" y2="54.5518498%" id="icon-gift-gray-5">
        <stop stopColor="#313137" offset="0%" />
        <stop stopColor="#313137" offset="0%" />
        <stop stopColor="#2C2C32" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="100%" x2="50%" y2="2.07981419%" id="icon-gift-gray-6">
        <stop stopColor="#FFFFFF" stopOpacity="0" offset="0%" />
        <stop stopColor="#FFFFFF" stopOpacity="0.0370137675" offset="100%" />
      </linearGradient>
      {/* end IconGiftGray */}

      {/* IconGift */}
      <radialGradient id="icon-gift-a" r="162.482%" fx="50%" fy="50%" gradientTransform="rotate(67.41 .5 .5) scale(1 1.00179)">
        <stop offset="0%" stopColor="#FFDAB2" stopOpacity="0" />
        <stop offset="6.654%" stopColor="#FFDAB2" stopOpacity=".32" />
        <stop offset="25.715%" stopColor="#FFDAB2" stopOpacity="0" />
        <stop offset="99.834%" stopColor="#FFDAB2" stopOpacity="0" />
      </radialGradient>
      <linearGradient id="icon-gift-b" x1="50%" x2="50%" y1="4.445%" y2="97.809%">
        <stop offset="0%" stopColor="#FF955F" />
        <stop offset="100%" stopColor="#FFD192" />
      </linearGradient>
      <linearGradient id="icon-gift-c" x1="47.095%" x2="50%" y1="-28.452%" y2="105.72%">
        <stop offset="0%" stopColor="#FFAB64" />
        <stop offset="100%" stopColor="#FF2641" stopOpacity=".989" />
      </linearGradient>
      <linearGradient id="icon-gift-d" x1="50%" x2="56.658%" y1="30.606%" y2="68%">
        <stop offset="0%" stopColor="#FFB60D" />
        <stop offset="100%" stopColor="#FF6110" />
      </linearGradient>
      <radialGradient id="icon-gift-e" r="47.592%" fx="50%" fy="50%">
        <stop offset="0%" stopColor="#FFF7E6" stopOpacity=".831" />
        <stop offset="43.861%" stopColor="#FFE0A8" stopOpacity=".251" />
        <stop offset="100%" stopColor="#FFE2B8" stopOpacity="0" />
      </radialGradient>
      <linearGradient id="icon-gift-f" x1="23.855%" x2="50%" y1="27.485%" y2="65.991%">
        <stop offset="0%" stopColor="#FF5F3F" />
        <stop offset="100%" stopColor="#E62E2E" stopOpacity=".989" />
      </linearGradient>
      <radialGradient id="icon-gift-h" cx="32.604%" cy="35.13%" r="76.548%" fx="32.604%" fy="35.13%" gradientTransform="matrix(.13446 .968 -.58853 .28484 .489 -.064)">
        <stop offset="0%" stopColor="#FF7E57" stopOpacity=".5" />
        <stop offset="100%" stopColor="#F88" stopOpacity="0" />
      </radialGradient>
      <path id="icon-gift-g" d="M0 0h56v19.744c0 3.567-.371 4.86-1.069 6.163a7.27 7.27 0 0 1-3.024 3.024C50.604 29.63 49.311 30 45.744 30H10.256c-3.567 0-4.86-.371-6.163-1.069a7.27 7.27 0 0 1-3.024-3.024C.37 24.604 0 23.311 0 19.744V0z" />
      <filter id="icon-gift-i" width="108.9%" height="116.7%" x="-4.5%" y="-8.3%" filterUnits="objectBoundingBox">
        <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="1.5" />
        <feOffset dx="-2" dy="-2" in="shadowBlurInner1" result="shadowOffsetInner1" />
        <feComposite in="shadowOffsetInner1" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner1" />
        <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 0.537392437 0 0 0 0 0.144291098 0 0 0 0 0.144291098 0 0 0 0.770104895 0" />
      </filter>
      <linearGradient id="icon-gift-j" x1="50%" x2="50.473%" y1="-3.873%" y2="100%">
        <stop offset="0%" stopColor="#FFC53F" />
        <stop offset="78.785%" stopColor="#FFBF2A" />
        <stop offset="89.102%" stopColor="#F39125" />
        <stop offset="100%" stopColor="#8D3B00" />
      </linearGradient>
      <linearGradient id="icon-gift-k" x1="50%" x2="54.152%" y1="47.697%" y2="53.473%">
        <stop offset="0%" stopColor="#FF6660" />
        <stop offset="100%" stopColor="#E62E2E" />
      </linearGradient>
      <radialGradient id="icon-gift-l" cx="-3.85%" cy="-146.76%" r="372.277%" fx="-3.85%" fy="-146.76%" gradientTransform="scale(-.22222 -1) rotate(-84.472 1.684 -.117)">
        <stop offset="0%" stopColor="#FFC464" />
        <stop offset="100%" stopColor="#FFB86B" stopOpacity="0" />
      </radialGradient>
      <path id="icon-gift-m" d="M72 95h56l6.553 13.106a2 2 0 0 1-1.79 2.894H67.237a2 2 0 0 1-1.789-2.894L72 95z" />
      <filter id="icon-gift-n" width="100.7%" height="118.8%" x="-.4%" y="-9.4%" filterUnits="objectBoundingBox">
        <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation=".5" />
        <feOffset dx="-1" dy="-1" in="shadowBlurInner1" result="shadowOffsetInner1" />
        <feComposite in="shadowOffsetInner1" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner1" />
        <feColorMatrix in="shadowInnerInner1" result="shadowMatrixInner1" values="0 0 0 0 0.447265625 0 0 0 0 0 0 0 0 0 0 0 0 0 0.244454764 0" />
        <feGaussianBlur in="SourceAlpha" result="shadowBlurInner2" stdDeviation="1" />
        <feOffset dx="1" dy="1" in="shadowBlurInner2" result="shadowOffsetInner2" />
        <feComposite in="shadowOffsetInner2" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner2" />
        <feColorMatrix in="shadowInnerInner2" result="shadowMatrixInner2" values="0 0 0 0 1 0 0 0 0 0.944975242 0 0 0 0 0.784146341 0 0 0 0.378660402 0" />
        <feMerge>
          <feMergeNode in="shadowMatrixInner1" />
          <feMergeNode in="shadowMatrixInner2" />
        </feMerge>
      </filter>
      <radialGradient id="icon-gift-o" cy="-50.166%" r="136.252%" fx="50%" fy="-50.166%" gradientTransform="matrix(0 1 -.37992 0 .31 -1.002)">
        <stop offset="0%" stopColor="#FFD083" />
        <stop offset="100%" stopColor="#FFC88D" stopOpacity="0" />
      </radialGradient>
      <linearGradient id="icon-gift-p" x1="50%" x2="50%" y1="4.731%" y2="100%">
        <stop offset="0%" stopColor="#FFE2B8" stopOpacity="0" />
        <stop offset="41.528%" stopColor="#FFE0A8" stopOpacity=".048" />
        <stop offset="100%" stopColor="#FFDC91" stopOpacity=".254" />
      </linearGradient>
      <linearGradient id="icon-gift-q" x1="50%" x2="50%" y1="4.731%" y2="100%">
        <stop offset="0%" stopColor="#FFE2B8" stopOpacity="0" />
        <stop offset="41.528%" stopColor="#FFE0A8" stopOpacity=".048" />
        <stop offset="100%" stopColor="#FFDC91" stopOpacity=".227" />
      </linearGradient>
      <linearGradient id="icon-gift-r" x1="50%" x2="56.658%" y1="1.946%" y2="94.599%">
        <stop offset="0%" stopColor="#FFB60D" />
        <stop offset="100%" stopColor="#FF6110" />
      </linearGradient>
      <linearGradient id="icon-gift-s" x1="45.198%" x2="50%" y1="-28.452%" y2="105.72%">
        <stop offset="0%" stopColor="#FFAB64" />
        <stop offset="100%" stopColor="#FF2641" stopOpacity=".989" />
      </linearGradient>
      <linearGradient id="icon-gift-t" x1="23.855%" x2="50%" y1="-12.805%" y2="94.607%">
        <stop offset="0%" stopColor="#FFAB64" />
        <stop offset="100%" stopColor="#FF2641" stopOpacity=".989" />
      </linearGradient>
      <linearGradient id="icon-gift-u" x1="43.464%" x2="50%" y1="-28.452%" y2="105.72%">
        <stop offset="0%" stopColor="#FFAB64" />
        <stop offset="100%" stopColor="#FF2641" stopOpacity=".989" />
      </linearGradient>
      {/* end IconGift */}

      {/* IconInputError */}
      <clipPath id="icon-input-error-0">
        <rect width="12" height="12" fill="white" transform="translate(4 4)" />
      </clipPath>
      {/* end IconInputError */}

      {/* IconArrowCircled */}
      <clipPath id="icon-arrow-circled">
        <path fill="#fff" transform="translate(0 .5)" d="M0 0h30v30H0z" />
      </clipPath>
      {/* end IconArrowCircled */}

      {/* User loyalty progress bar gradient */}
      <linearGradient id="loyalty-progress-linear-gradient">
        <stop stopColor={colors.primary} />
        <stop offset="1" stopColor={colors.secondary} />
      </linearGradient>
      {/* User loyalty progress bar gradient */}

      {/* IconStatusFailed */}
      <clipPath id="icon-status-failed">
        <rect width="10.2857" height="10.2857" fill="white" transform="translate(3.85742 3.85712)" />
      </clipPath>
      {/* end IconStatusFailed */}

      {/* IconClock */}
      <clipPath id="icon-clock">
        <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
      </clipPath>
      {/* end IconClock */}

      {/* IconStatusRequired */}
      <clipPath id="icon-status-required">
        <rect width="10.2857" height="10.2857" fill="white" transform="translate(3.85742 3.85706)" />
      </clipPath>
      {/* end IconStatusRequired */}

      {/* IconLogoMobile */}
      <linearGradient id="icon-logo-mobile-0" x1="30" y1="4" x2="30" y2="14" gradientUnits="userSpaceOnUse">
        <stop stopColor="#B38D14" />
        <stop offset="0.4375" stopColor="#D9B84F" />
        <stop offset="0.572917" stopColor="#D9B84F" />
        <stop offset="1" stopColor="#B08B12" />
      </linearGradient>
      <linearGradient id="icon-logo-mobile-1" x1="30.5" y1="16" x2="30.5" y2="27" gradientUnits="userSpaceOnUse">
        <stop stopColor="#B38D14" />
        <stop offset="0.4375" stopColor="#D9B84F" />
        <stop offset="0.572917" stopColor="#D9B84F" />
        <stop offset="1" stopColor="#B08B12" />
      </linearGradient>
      <linearGradient id="icon-logo-mobile-2" x1="34.9039" y1="0.800003" x2="34.9039" y2="15.0092" gradientUnits="userSpaceOnUse">
        <stop stopColor="#1D7048" />
        <stop offset="1" stopColor="#2F125F" />
      </linearGradient>
      <clipPath id="icon-logo-mobile-3">
        <rect width="86" height="30" fill="white" />
      </clipPath>
      {/* end IconLogoMobile */}

      {/* IconLogo */}
      <clipPath id="logo-clip">
        <rect width="223" height="68" fill="white" />
      </clipPath>
      {/* end IconLogo */}

      {/* IconLineApp */}
      <clipPath id="icon-line-app">
        <rect width="20" height="20" fill="white" transform="translate(0.1875)" />
      </clipPath>
      {/* end IconLineApp */}

      {/* IconLogoLarge start */}
      <linearGradient id="icon-logo-large-linear-1" x1="153.947" y1="-9.5851e-08" x2="155.234" y2="39.9993" gradientUnits="userSpaceOnUse">
        <stop stopColor="#CF493C" />
        <stop offset="0.463988" stopColor="#C14C44" />
        <stop offset="0.470953" stopColor="#B32B1F" />
        <stop offset="1" stopColor="#9B2C27" />
      </linearGradient>
      <linearGradient id="icon-logo-large-linear-2" x1="44.2679" y1="-9.09022e-08" x2="45.9449" y2="39.9988" gradientUnits="userSpaceOnUse">
        <stop stopColor="white" />
        <stop offset="0.561973" stopColor="#EFEFF3" />
        <stop offset="0.568185" stopColor="#EAEAEF" />
        <stop offset="1" stopColor="#DBDCE4" />
      </linearGradient>
      <linearGradient id="icon-logo-large-linear-3" x1="44.6375" y1="5.02002" x2="45.6421" y2="30.771" gradientUnits="userSpaceOnUse">
        <stop stopColor="#CF493C" />
        <stop offset="0.669411" stopColor="#C14C44" />
        <stop offset="0.687132" stopColor="#B32B1F" />
        <stop offset="1" stopColor="#9B2C27" />
      </linearGradient>
      <clipPath id="icon-logo-large-clippath">
        <rect width="222" height="40" fill="white" />
      </clipPath>
      {/* IconLogoLarge end */}

      {/* IconLogoMobile start */}
      <linearGradient id="icon-logo-mobile-linear" x1="19.9877" y1="12.5" x2="19.9877" y2="20.469" gradientUnits="userSpaceOnUse">
        <stop stopColor="#CF493C" />
        <stop offset="1" stopColor="#9B2C27" />
      </linearGradient>
      <clipPath id="icon-logo-mobile-clip-0">
        <rect width="40" height="40" fill="white" />
      </clipPath>
      <clipPath id="icon-logo-mobile-clip-1">
        <rect width="40" height="40" fill="white" />
      </clipPath>
      <clipPath id="icon-logo-mobile-clip-2">
        <rect width="36" height="18" fill="white" transform="translate(2 11)" />
      </clipPath>
      <linearGradient id="icon-logo-mobile-paint0_linear_7455_146568" x1="19.9466" y1="16" x2="19.9466" y2="23.894" gradientUnits="userSpaceOnUse">
        <stop stopColor="#1D7048" />
        <stop offset="1" stopColor="#2F125F" />
      </linearGradient>
      <clipPath id="icon-logo-mobile-clip0_7455_146568">
        <rect width="40" height="40" fill="white" />
      </clipPath>
      <clipPath id="icon-logo-mobile-clip1_7455_146568">
        <rect width="40" height="40" fill="white" />
      </clipPath>
      <clipPath id="icon-logo-mobile-clip2_7455_146568">
        <rect width="38" height="8" fill="white" transform="translate(1 16)" />
      </clipPath>
      {/* IconLogoMobile end */}

      {/* IconPep start */}
      <clipPath id="icon-pep-clip">
        <rect width="30" height="30" fill="white" transform="translate(0.169189 0.5)" />
      </clipPath>
      {/* IconPep end */}

      {/* IconPaybol start */}
      <clipPath id="icon-paybol-clip">
        <rect width="98" height="30" fill="white" transform="translate(0.169189 0.5)" />
      </clipPath>
      {/* IconPaybol end */}

      {/* IconLogo */}
      <linearGradient id="icon-logo-linear" x1="106.113" y1="0" x2="106.113" y2="39.4701" gradientUnits="userSpaceOnUse">
        <stop stopColor={colors.primary} />
        <stop offset="1" stopColor={colors.secondary} />
      </linearGradient>
      {/* end IconLogo */}

      {/* IconPlayCircle */}
      <linearGradient id="icon-play-circle-linear" x1="48" y1="24.5" x2="0" y2="24.5" gradientUnits="userSpaceOnUse">
        <stop stopColor="#1D7048" />
        <stop offset="1" stopColor="#2F125F" />
      </linearGradient>
      {/* end IconPlayCircle */}

      {/* IconAll */}
      <clipPath id="clip-icon-all">
        <rect width="28" height="28" fill="white" />
      </clipPath>
      {/* IconAll end */}

      {/* IconSport */}
      <clipPath id="clip_icon_sport">
        <rect width="28" height="28" fill="white" />
      </clipPath>
      {/* IconSport end */}

      {/* IconNew */}
      <clipPath id="clip_icon_new">
        <rect width="28" height="28" fill="white" />
      </clipPath>
      {/* IconNew end */}

      {/* IconPopypara */}
      <filter id="icon-popypara-1" x="34.2261" y="7.76129" width="29.1059" height="15.4887" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dx="0.31" dy="-0.31" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_17822_62157" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_17822_62157" result="shape" />
      </filter>
      <pattern id="icon-popypara-pattern" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use xlinkHref="#image0_17822_62157" transform="scale(0.0172414)" />
      </pattern>
      <linearGradient id="icon-popypara-paint" x1="57.508" y1="8.0601" x2="41.698" y2="23.2501" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFA620" />
        <stop offset="1" stopColor="#D5861A" />
      </linearGradient>
      <image id="image0_17822_62157" width="58" height="58" xlinkHref="data:image/png;base64,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" />
      {/* IconPopypara end */}

      {/* IconProviderEgtDigital */}
      <clipPath id="icon-provider-egt-digital-1">
        <rect width="60" height="60" fill="white" />
      </clipPath>
      {/* end IconProviderEgtDigital */}

      {/* IconProviderSlotopiaBig */}
      <clipPath id="icn-provider-slotopia-big-1">
        <rect width="141" height="30.9581" fill="white" />
      </clipPath>
      {/* end IconProviderSlotopiaBig */}

      {/* IconProviderSlotopia */}
      <clipPath id="clip-icon-provider-slotopia">
        <rect width="22" height="27" fill="white" />
      </clipPath>
      {/* end IconProviderSlotopia */}

      {/* IconProviderElaGames */}
      <clipPath id="clip0_19072_45608">
        <rect width="20" height="20" fill="white" transform="translate(4 4)" />
      </clipPath>
      {/* end IconProviderElaGames */}

      {/* IconFormulaSpin */}
      <clipPath id="clip0_685_1729">
        <rect width="60" height="60" fill="white" />
      </clipPath>
      {/* end  IconFormulaSpin */}
    </defs>
  </svg>
);
